import { render, staticRenderFns } from "./LoyaltyCardPictogram.vue?vue&type=template&id=1447c772"
import script from "./LoyaltyCardPictogram.vue?vue&type=script&lang=js"
export * from "./LoyaltyCardPictogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports